import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { DELETE, GET, UPDATE } from "../constants/request-type";
import {
  city,
  delete_user,
  get_all_city,
  get_all_province,
  get_all_user,
  province,
  user
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";

import { CSVLink } from "react-csv";
import Check_kyc from "../forms/chef_kyc";
import { decryptSingleData } from "../functions/cryptojs";

import logger from "../../utils/logger.js";
const { RangePicker } = DatePicker;

const { Option } = Select;

const token = sessionStorage.getItem("auth_token");

class UserChef extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    province: [],
    city: [],
    start: null,
    end: null,
    province_selected: null,
    city_selected: null,
    overall: true,
    allowed: false,
    blocked: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: user + "/" + get_all_user,
      data: null,
      token: token
    };

    const request_details_province = {
      type: GET,
      url: service_api,
      route: province + "/" + get_all_province,
      data: null,
      token: token
    };

    const request_details_city = {
      type: GET,
      url: service_api,
      route: city + "/" + get_all_city,
      data: null,
      token: token
    };

    try {
      const [response, response_province, response_city] = await Promise.all([
        MakeRequestAsync(request_details),
        MakeRequestAsync(request_details_province),
        MakeRequestAsync(request_details_city)
      ]);

      this.setState({
        data: decryptSingleData(response?.data?.user),
        province: decryptSingleData(response_province?.data?.province),
        city: decryptSingleData(response_city?.data?.city),
        load: false
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + id,
      data: data,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };
  handleVisible = async (id, status) => {
    const data = {
      visible: status
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + id,
      data: data,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: user + "/" + delete_user + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id")
      },
      {
        title: "Nom",
        dataIndex: "firstname",

        ...this.getColumnSearchProps("firstname")
      },
      {
        title: "Prénom",
        dataIndex: "lastname",

        ...this.getColumnSearchProps("lastname")
      },
      {
        title: "Email",
        dataIndex: "email",

        ...this.getColumnSearchProps("email")
      },
      {
        title: "Contact",
        dataIndex: "number",

        ...this.getColumnSearchProps("number"),

        render: (text) => (
          <a href={text === "" ? "" : `tel:${text}`}>
            {text === "" ? "Aucun contact" : text}
          </a>
        )
      },
      {
        title: "Safety Certificate",
        dataIndex: "images",
        render: (text, record) => (
          <>
            {record?.certificate_safety?.pic === null ? (
              "Aucune photo"
            ) : (
              <a
                href={record?.certificate_safety?.pic}
                target="_blank"
                rel="noreferrer"
              >
                Image certificat
              </a>
            )}
            <br />
            <Tag color="purple">
              Expiration: {record?.certificate_safety?.expirity}
            </Tag>
          </>
        )
      },
      {
        title: "Photos profile",
        dataIndex: "images",
        render: (text, record) => (
          <>
            {record?.pic1 === null ? (
              "Aucune photo (1)"
            ) : (
              <a href={record?.pic1} target="_blank" rel="noreferrer">
                Image 1
              </a>
            )}
            <br />
            {record?.pic2 === null ? (
              "Aucune photo (2)"
            ) : (
              <a href={record?.pic2} target="_blank" rel="noreferrer">
                Image 2
              </a>
            )}
            <br />
            {record?.pic3 === null ? (
              "Aucune photo (3)"
            ) : (
              <a href={record?.pic3} target="_blank" rel="noreferrer">
                Image 3
              </a>
            )}
            <br />
            {record?.preview === null ? (
              "Aucune bannière"
            ) : (
              <a href={record?.preview} target="_blank" rel="noreferrer">
                bannière
              </a>
            )}
          </>
        )
      },
      {
        title: "Visible",
        dataIndex: "visible",
        render: (text) =>
          text === true ? (
            <Tag color={"green"} key={text}>
              Oui
            </Tag>
          ) : (
            <Tag color={"volcano"} key={text}>
              Non
            </Tag>
          )
      },
      {
        title: "Actif",
        dataIndex: "status",
        render: (text) =>
          text === true ? (
            <Tag color={"green"} key={text}>
              Oui
            </Tag>
          ) : (
            <Tag color={"volcano"} key={text}>
              Non
            </Tag>
          )
      },
      {
        title: "Création",
        dataIndex: "createdAt",
        render: (text) => <Tag>{text?.slice(0, 16)}</Tag>
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Check_kyc row={record} />
        </Menu.Item>
        {record.visible === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, true)}>
              Rendre visible
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, false)}>
              Rendre invisible
            </Link>
          </Menu.Item>
        )}

        {record.status === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Activer
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Desactiver
            </Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item>
      </Menu>
    );

    const {
      load,
      data,
      start,
      end,
      province,
      city,
      province_selected,
      city_selected
    } = this.state;
    return (
      <>
        <PageHeader
          title="Chefs"
          tags={<Tag color="blue">Liste des chefs</Tag>}
          subTitle=""
          extra={[
            <RangePicker
              showTime
              onChange={(data) => {
                logger.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            // <User_new />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data
                  ?.filter((data) => {
                    if (city_selected !== null) {
                      return (
                        data.province === province_selected &&
                        data.city === city_selected &&
                        data.chef === true
                      );
                    }
                    if (province_selected !== null) {
                      return (
                        data.province === province_selected &&
                        data.chef === true
                      );
                    }

                    return data.chef === true;
                  })
                  ?.filter((item) => {
                    if (start === null && end === null) {
                      return item;
                    }
                    return item.createdAt >= start && item.createdAt <= end;
                  }).length
              }
            />
          </Row>
          <Row gutter={16}>
            {!load && (
              <>
                <Col span={4}>
                  <Form.Item
                    label="Province"
                    rules={[
                      {
                        required: true,
                        role: "province"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Province"
                      defaultValue={province_selected}
                      onChange={(data) => {
                        return this.setState({ province_selected: data });
                      }}
                    >
                      {province?.map((item) => (
                        <Option key={item?.province}>
                          <span>{item?.province}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    label="Ville"
                    rules={[
                      {
                        required: true,
                        role: "Ville"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Ville"
                      defaultValue={city_selected}
                      onChange={(data) => {
                        return this.setState({ city_selected: data });
                      }}
                    >
                      {city
                        ?.filter((item) => {
                          return item.province.province === province_selected;
                        })
                        .map((item) => (
                          <Option key={item?.city}>
                            <span>{item?.city}</span>
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row>
            {load ? (
              <Space size="middle" style={{ marginTop: 20 }}>
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24} style={{ marginTop: 20 }}>
                <Table
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data
                    ?.filter((data) => {
                      if (city_selected !== null) {
                        return (
                          data.province === province_selected &&
                          data.city === city_selected &&
                          data.chef === true
                        );
                      }
                      if (province_selected !== null) {
                        return (
                          data.province === province_selected &&
                          data.chef === true
                        );
                      }

                      return data.chef === true;
                    })
                    ?.filter((item) => {
                      if (start === null && end === null) {
                        return item;
                      }
                      return item.createdAt >= start && item.createdAt <= end;
                    })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(UserChef);
